import React, { useState, useContext } from "react";
import axios from "axios";
import { UPLOAD_FILE_URL } from "../Utils/URLs";
import { toast } from "react-toastify"
import { UserContext } from "./UserContext";
const FileState = () => {
    const [progress, setProgress] = useState(0)
    const [fileformBusy, setFileFormBusy] = useState(false)
    const [fileresponse, setFileResponse] = useState("")
    const [freeRideData, setFreeRideData] = useState([])
    const { UpdateUser } = useContext(UserContext)
    
    const token = localStorage.getItem("token")

    const UploadFile = async (data) => {

        try {
            setFileFormBusy(true)
            await axios.post(UPLOAD_FILE_URL, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((res) => {
                console.log(res.data)
                
                if (res.data.type === "success") {
                    
                    // Set file response for success handling
                    setFileResponse(res.data)
                }

            })
            setFileFormBusy(false)
        } catch (error) {
            console.log(error)
            setFileFormBusy(false)
        }
    }



    return {
        UploadFile,
        fileformBusy,
        fileresponse,
        progress,

    }
}

export default FileState